<template>
  <div class="content-panel panel" compact>
    <div :class="title_classes">
      {{ branded_fare | capitalize }}
    </div>
    <div class="branded-fare-upsell__price">
      {{ formatted_price }} {{ item.price.currencySymbol }}
    </div>
    <div class="branded-fare-upsell__separator fullwidth"></div>

    <branded-fare-amenity :item="bag_summary_item" with_separator />
    <branded-fare-amenity :item="services_summary_item" />

    <div>
      <div
        v-b-modal="`modal-${_uid}${index}`"
        class="branded-fare-upsell__show-all"
      >
        Vedi tutti i servizi
      </div>

      <vb-modal
        :vb_options="{
          id: `modal-${_uid}${index}`,
          size: 'lg',
          title: 'Servizi inclusi',
          modal_class: 'branded-fare-upsell__modal',
          hide_footer: true,
        }"
      >
        <branded-fare-amenity
          v-for="(amenity, amenity_index) in filtered_amenities"
          :key="`amenities:${_uid}:${amenity_index}-all`"
          :item="get_amenity_info(amenity)"
          with_separator
        />
      </vb-modal>
    </div>
    <div class="branded-fare-upsell__actions">
      <div>
        <!--flexbox-->
        <vb-button
          :vb_options="{
            variant: is_selected ? 'outline-info' : 'info',
            block: true,
            disabled: is_button_disabled,
            text: fare_button_text,
          }"
          @click="() => $emit('select-flight-offer', item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { get_branded_fare, get_bags } from '@liveflight/providers';
  import { apply_markup_to_number } from '@liveflight/utilities/price';
  import { get_amenity_info } from '@liveflight/resources';
  import {
    show_amenity,
    toggle_selected_class,
    get_fare_button_text,
  } from './logic';
  import BrandedFareAmenity from './amenity.vue';

  export default {
    name: 'branded-fare-upsell-swiper-item',
    components: {
      'branded-fare-amenity': BrandedFareAmenity,
    },
    props: {
      item: { type: Object, required: true },
      index: { type: Number, required: true },
      selected_flight_offer_id: [String, Number],
      flight_offer_default: Object,
      // Amenities for this offer, derived by the parent (with placeholder
      // fallback for LCC fares that ship none) so the offer prop stays
      // unmutated.
      amenities: { type: Array, default: () => [] },
    },
    computed: {
      branded_fare() {
        return get_branded_fare(this.item);
      },
      formatted_price() {
        return apply_markup_to_number(this.item, this.item.price.grandTotal);
      },
      bag_summary_item() {
        const info = get_amenity_info({ code: '0CH' });
        return { ...info, txt: `${info.txt}: ${get_bags(this.item).total}` };
      },
      services_summary_item() {
        const info = get_amenity_info({
          code: '',
          description: 'Servizi inclusi',
        });
        return {
          ...info,
          txt: `${info.txt}: ${this.filtered_amenities.length}`,
        };
      },
      filtered_amenities() {
        return this.amenities.filter((a) => show_amenity(a));
      },
      is_selected() {
        return this.item.id === this.selected_flight_offer_id;
      },
      is_button_disabled() {
        return (
          this.is_selected && this.item.id === this.flight_offer_default.id
        );
      },
      fare_button_text() {
        return get_fare_button_text(
          this.item,
          this.selected_flight_offer_id,
          this.flight_offer_default
        );
      },
      title_classes() {
        const modifier = toggle_selected_class(
          this.item,
          this.selected_flight_offer_id
        );
        return `branded-fare-upsell-swiper-item__title branded-fare-upsell-swiper-item__title--${modifier}`;
      },
    },
    methods: {
      get_amenity_info,
    },
  };
</script>

<style lang="scss" scoped>
  .branded-fare-upsell-swiper-item {
    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      text-transform: capitalize;
      &--selected {
        color: var(--primary);
      }
    }
  }
</style>
